const badges = [
  "Simple CSV Upload",
  "No complex setup",
  "Actionable insights",
  "Works without a POS",
  "Results in minutes",
];

export default function TrustStrip() {
  return (
    <div className="sm-trust">
      <div className="sm-trust-inner">
        <span className="sm-trust-label">
          Built for growing retail businesses across India
        </span>

        <div className="sm-trust-badges">
          {badges.map((badge, index) => (
            <span key={index} className="sm-badge">
              <span className="sm-badge-icon">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none">
                  <path
                    d="M1.5 4L3.5 6L6.5 2"
                    stroke="#E8F0EB"
                    strokeWidth="1.3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}